import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "bp-pill-group",
	template: `
		<div class="bp-pill-group">
			<ng-content></ng-content>
		</div>
	`,
	styleUrls: ["./bp-pill-group.component.scss"],
	// eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpPillGroupComponent {}
